import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid, Button} from '@mui/material'
import {DocumentService} from '../../../services';
import CustomDataGrid  from '../../../customUtil/DataGrid';

const columns = [
    {
        field: 'title', headerName: 'Title', width: 730,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/templates/document/' + params.row.id}>
                {params.value}
            </Link>
        )
    }
]

const Documents = () => {
        const [list, setList] = React.useState([]);

       // const [ready, setReady] = React.useState(false);
        React.useEffect(() => {
            DocumentService.getAll()
                .then((response) => {
                    setList(response.data);
                });
        }, []);

        return (
            <Container>
                <header>
                    <h1>Documents</h1>
                </header>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                                <Button variant='contained' color='primary' component={RouterLink} to='/templates/document/new'>Create New</Button>
                            </Grid>                 
                    <Grid item xs={12}>
                    <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                               />                      
                    </Grid>
                </Grid>
            </Container>
        );
    }
;

export default Documents;
